"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MenuPanelContainer;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
require("./index.scss");
var _formatVodData2 = require("../../utils/formatVodData");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function MenuPanelContainer({
  data,
  children,
  commonStyle,
  domains: domainInfos
}) {
  const bgImg = data.bgImg,
    color = data.color;
  const _formatVodData = (0, _formatVodData2.formatVodData)(bgImg),
    url = _formatVodData.url;
  const bgStyle = {};
  if (color) {
    bgStyle['background'] = color;
  }
  if (url) {
    bgStyle['background'] = `url(${url})`;
  }
  const renderChild = child => {
    return child ? /*#__PURE__*/React.cloneElement(child, {
      domains: domainInfos
    }) : child;
  };
  return /*#__PURE__*/React.createElement("section", {
    className: "banner-container",
    id: "banner-container",
    style: bgStyle
  }, React.Children.map(children, (child, index) => /*#__PURE__*/React.createElement("div", {
    style: commonStyle,
    key: index,
    id: `banner-container-child-${index}`
  }, renderChild(child))));
}